import React from 'react';
import ColorInput from './color_input';
import ColorInputADG3 from './color_input_adg3';

export default function(props) {
  return props.adg3 ? <ColorInputADG3 {...props} /> : <ColorInput {...props} />;
}
